import { Suspense, lazy, memo, useMemo } from 'react';

import type { Item } from '../../model';
import { useMenuItems, useMenuOptions } from '../../store';

import { useWindowSize } from '@hooks/useWindowSize';

const Dropdown = lazy(() => import('../Dropdown'));
const Overlay = lazy(() => import('../Overlay'));

const More = () => {
  const {
    options: { isCorporateContext },
  } = useMenuOptions();

  const { isMobile, isHoverDevice } = useWindowSize();
  const isMobileOrTouch = isMobile || !isHoverDevice;
  const { items, trnItem, moreItems } = useMenuItems();

  const useHoverMenu = isCorporateContext && !isMobileOrTouch;

  // Full menu with Home button also
  const moreItemsList = useMemo(() => {
    if (isCorporateContext) {
      return (!isMobileOrTouch ? moreItems : items) ?? [];
    }

    return isMobile ? [{ ...trnItem, id: 'home', tag: 'nav_home' }, ...items] : (moreItems ?? []);
  }, [isCorporateContext, isMobile, trnItem, items, moreItems, isMobileOrTouch]);

  const moreItem: Item = useMemo(
    () => ({
      id: 'more',
      tag: 'more',
      trackText: 'More',
      isActive: moreItemsList.some((i) => i.isActive === true),
      menuItems: moreItemsList,
    }),
    [moreItemsList],
  );

  if (!moreItemsList.length) return null;

  return (
    <Suspense>
      {useHoverMenu ? <Overlay item={moreItem} isMoreMenu /> : <Dropdown item={moreItem} isMoreMenu />}
    </Suspense>
  );
};

export default memo(More);
